import {
  createReactRouterV7DataOptions,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { matchRoutes } from "react-router";

export const FARO_COLLECTOR_URL =
  "https://faro-collector-prod-gb-south-1.grafana.net/collect/f44ddd336dbbaba649773fd0e68012a2";

export const FARO_APP_NAME = "client-access-sandbox-ui";
export const FARO_APP_ENVIRONMENT = "production";

export const isFaroEnabled = import.meta.env.MODE === "prod";

export const initFaro = () => {
  if (!isFaroEnabled) {
    return;
  }

  initializeFaro({
    url: FARO_COLLECTOR_URL,
    app: {
      name: FARO_APP_NAME,
      version: "1.0.0",
      environment: FARO_APP_ENVIRONMENT,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
      new ReactIntegration({
        router: createReactRouterV7DataOptions({ matchRoutes }),
      }),
    ],
  });
};
